import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFence = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 10H10M14 16H18M14 10H18M6 16H10M10 20H14V7L12 4L10 7V20ZM2 20H6V7L4 4L2 7V20ZM18 20H22V7L20 4L18 7V20Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFence;
